export default {

    data() {
        return {
            isLoading: false,
        };
    },

    methods: {

        withLoadingBoundary(promise) {
            this.isLoading = true;
            promise().finally(() => {
                this.isLoading = false;
            });
        },

    },
};
